import { render, staticRenderFns } from "./AndroidGuide.vue?vue&type=template&id=ff5bc396&scoped=true"
import script from "./AndroidGuide.vue?vue&type=script&lang=js"
export * from "./AndroidGuide.vue?vue&type=script&lang=js"
import style0 from "./AndroidGuide.vue?vue&type=style&index=0&id=ff5bc396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5bc396",
  null
  
)

export default component.exports